<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productRecipe.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productRecipe.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end ts-items-center">
          <div class="ts-flex ts-space-x-3">
            <select 
                v-tooltip="$t('productRecipe.productType')"
                v-model="productTypeId"
                class="form-control"
            >
              <option :value="1">Assembly</option>
              <option :value="2">Non-Assembly</option>
            </select>
            <ts-input
              v-tooltip="$t('productRecipe.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.barcode }}</td>
            <td>{{ record.group ? record.group.pro_group_name_en : null }}</td>
            <td>{{ record.product_name_kh }}</td>
            <td>{{ record.product_name_en }}</td>
            <td>{{ record.product_category.category_name_en }}</td>
            <td class="ts-w-3">
              <span
                class="badge badge-success"
                v-if="record.product_add_on_count"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('add_new')"
                @click.prevent="chosen(record)"
              >
                <i class="fa fa-plus"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'addOnIndex',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/addOn', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.addOn.search
      },
      set(newValue) {
        this.$store.commit('product/addOn/SET_SEARCH', newValue)
        this.$store.commit('product/addOn/RESET_CURRENT_PAGE')
      },
    },
    productTypeId: {
      get() {
        return this.$store.state.product.addOn.product_type_id
      },
      set(newValue) {
        this.$store.commit('product/addOn/SET_PRODUCT_TYPE_ID', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('productRecipe.barcode'), style: 'width: 11%' },
        { name: this.$t('productRecipe.group') },
        { name: this.$t('productRecipe.nameKh') },
        { name: this.$t('productRecipe.nameEn') },
        { name: this.$t('productRecipe.category') },
        { name: this.$t('productRecipe.addOn') },
        { name: this.$t('actions'), style: 'text-align:center; width:80px' },
      ]
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/addOn/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    chosen(record) {
      this.$router.push({
          name: 'product-add-on-create',
          params: {
              id: record.product_id
          },
          query: {
              product_type_id: record.product_type_id
          }
      })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    productTypeId: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/addOn/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
    })
  },
}
</script>